import React, { useContext, useState } from "react";
import Button from "../button/Button";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UseContext";
import { toast } from "sonner";
import axios from "../../api/axios";
import { Card } from "../Card";

function LogoutPrompt({ closeModal }) {
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const { setToken, setSignedUp, setProfile } = useContext(UserContext);

  const handleLogout = async () => {
    setDisabled(true);
    const token = localStorage.getItem("arena_xp_token");
    try {
      const res = await axios.get("/audiences/logout", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (res.status === 204) {
        setToken("");
        setProfile("");
        setSignedUp(false);
        localStorage.removeItem("arena_xp_token");
        localStorage.removeItem("user");
        localStorage.removeItem("profile");
        localStorage.removeItem("signedUp");
        toast.warning("You have logged out of your account");
        navigate("/");
      }
    } catch (err) {
      setDisabled(false);
      toast.error(err.response.data.message);
    }
  };

  return (
    <Card className="!rounded-[20px] max-w-[400px] w-full flex justify-center items-center flex-col ">
      <h2 className="pb-2.5 text-xl text-primary-black font-semibold text-center">
        Ready to log out?
      </h2>
      <p className="text-base font-medium text-primary-black text-center max-w-[304px] w-full">
        You’ll need to sign in again to access your account. Any unsaved changes
        may be lost.
      </p>
      <div className="flex items-center mt-7 justify-evenly w-full">
        <div className="max-w-[137px] w-full ">
          <Button
            className="min-w-[90px] !w-full !shadow-none"
            text="Log Out"
            onClick={handleLogout}
            disabled={disabled}
          />
        </div>
        <div className="max-w-[137px] w-full">
          <Button
            style={{ backgroundColor: "red" }}
            text="Cancel"
            onClick={closeModal}
            className="min-w-[90px]  !shadow-none logout_cancel  border border-[#000000] !text-primary-black"
          />
        </div>
      </div>
    </Card>
  );
}

export default LogoutPrompt;
